"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BaseCardHeader = /*#__PURE__*/function (_Component) {
  _inherits(BaseCardHeader, _Component);

  var _super = _createSuper(BaseCardHeader);

  function BaseCardHeader() {
    _classCallCheck(this, BaseCardHeader);

    return _super.apply(this, arguments);
  }

  _createClass(BaseCardHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id,
          title = _this$props.title,
          noBorder = _this$props.noBorder,
          secondaryFullWidth = _this$props.secondaryFullWidth;

      var mappedChildren = _react["default"].Children.map(children, function (child, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])({
            'ui-base-card-header__children-item--full': secondaryFullWidth
          }, 'ui-base-card-header__children-item'),
          key: index
        }, child);
      });

      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, id ? {
        id: id
      } : {}, {
        className: BaseCardHeader.headerClass({
          className: className,
          noBorder: noBorder
        })
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-base-card-header__main-content"
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        className: "ui-base-card-header__title"
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-base-card-header__children"
      }, mappedChildren)));
    }
  }], [{
    key: "headerClass",
    value: function headerClass(_ref) {
      var className = _ref.className,
          noBorder = _ref.noBorder;
      return (0, _classnames["default"])({
        'ui-base-card-header': true,
        'with-border': !noBorder
      }, className);
    }
  }]);

  return BaseCardHeader;
}(_react.Component);

BaseCardHeader.propTypes = {
  /** items to display on the right hand side of the Header */
  children: _propTypes["default"].node,

  /** className for reference */
  className: _propTypes["default"].string,

  /** id for reference */
  id: _propTypes["default"].string,

  /** Can be used to render a title in Card Header. */
  title: _propTypes["default"].node,

  /** Bool to allow a bottom border. */
  noBorder: _propTypes["default"].bool,

  /** If true, set the secondary width 50% */
  secondaryFullWidth: _propTypes["default"].bool
};
BaseCardHeader.defaultProps = {
  children: [],
  className: '',
  id: '',
  title: '',
  noBorder: false,
  secondaryFullWidth: false
};
var _default = BaseCardHeader;
exports["default"] = _default;